<template>
  <div class="modal modal-cart fade">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content text-center modal-cart__content">
        <button type="button" class="modal__close d-flex align-items-center justify-content-center" data-dismiss="modal">
          <svg-icon icon="close-remove"></svg-icon>
        </button>

        <div class="modal-cart__block modal-cart__block--top text-left mb-4" v-if="current_purchase">
          <div class="modal-cart__title">Товар добавлен в корзину</div>

          <div class="row align-items-center pb-4">
            <div class="mb-2 mb-md-0 col-3 col-sm-2 modal-cart__image">
              <img :src="current_purchase.product.thumb_url || '/img/no-image-available.png'" alt="">
            </div>
            <div class="col-9 col-sm-10 col-md-6 modal-cart__name">{{current_purchase.product.name}}</div>
            <div class="col-6 col-md-2 modal-cart__counter">
              <product-counter :purchase="current_purchase"></product-counter>
            </div>
            <div class="col-6 col-md-2 text-right  modal-cart__price"><price-formatted :value="current_purchase.product.price * current_purchase.amount"/></div>
          </div>

          <div class="row modal-cart__actions align-items-center">
            <div class="mb-2 mb-md-0 col-12 col-md modal-cart__info mr-md-3">
              <a :href="route('cart')" class="link-green">В корзине {{cart.total_products}} {{plural(cart.total_products, ['товар', 'товара', 'товаров'])}}</a> на сумму <price-formatted :value="cart.total_price"/>
            </div>
            <div class="mb-2 mb-md-0 col-12 col-sm-6 col-md">
              <div class="button-white modal-cart__button modal-cart__close-button mr-md-3" data-dismiss="modal">Продолжить покупки</div>
            </div>
            <div class="mb-2 mb-md-0 col-12 col-sm-6 col-md">
              <a class="d-block button-brown modal-cart__button modal-cart__cart-button" :href="route('cart')">Перейти в корзину</a>
            </div>
          </div>
        </div>

        <div class="modal-cart__block modal-cart__block--bottom text-left" v-if="related_products && related_products.length && related_products.filter(rp => !rp.exist_in_cart).length">
          <div class="modal-cart__related-title main-title main-title--smaller pb-4">Приятное дополнение к Вашему выбору</div>

          <div class="modal-cart__related-items row">
            <related-product v-for="rp in related_products" :rp="rp" :key="`rp-${rp.id}`"></related-product>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import RelatedProduct from './RelatedProduct'

  export default {
    data() {
      return {
        cart : window.CART_FULL,
        current_product_id : null,
        related_products : null,
      }
    },
    computed : {
      current_purchase() {
        if (!this.current_product_id)
          return null;

        return this.cart.purchases.find( pur => pur.purchase_idx == this.current_product_id)
      }
    },
    methods: {
      set(current_product_id, related_products) {
        this.current_product_id = current_product_id
        this.related_products = related_products
      },
    },
    mounted() {

    },
    components: {
      RelatedProduct
    },
    watch : {

    }
  }
</script>
